import {useContext} from "react";
import {StateContext} from "../Contexts";
import check_icon from "../../../img/check_2.svg";
import {
    addToCart,
    getMonthlyPriceForPlanVariant,
    getPlanVariantForPeriod, getPlanVariantPeriod
} from "../Billwerk/SubscriptionJS";
import {PERIOD_ANNUALLY, PERIOD_ANNUALLY_MONTHLY_PAID, PERIOD_MONTHLY} from "../Constants";
import formatCurrency from "../Util/formatCurrency";

export default function ({period, periodLabel, active, twoColumnMode, disabled}) {
    /** @type CheckoutState */
    const state = useContext(StateContext);

    let planVariantForPeriod = getPlanVariantForPeriod(state, period);

    const updateState = () => {
        // the button for period_annually should do nothing when monthly payment for annual subscription is selected
        if (period === PERIOD_ANNUALLY && state.period === PERIOD_ANNUALLY_MONTHLY_PAID) {
            return;
        }

        state.setPeriod(period);

        state.setCart(cart => addToCart(state, cart, {
            PlanVariantId: planVariantForPeriod.id
        }));
    };

    if (state.productInfo && !planVariantForPeriod) {
        return null;
    }

    if (state.mainProps.variantLocked && (
        !planVariantForPeriod
        || getPlanVariantPeriod(planVariantForPeriod, false) !== state.period
    )) {
        return null;
    }

    let isAnnualVariant = [PERIOD_ANNUALLY, PERIOD_ANNUALLY_MONTHLY_PAID].includes(period);

    let strikethroughPrice = !twoColumnMode && isAnnualVariant && planVariantForPeriod.strikethrough_price
        ? <span className="strikethrough-price !mr-0">{formatCurrency(planVariantForPeriod.strikethrough_price / 12, true)}</span>
        : <></>

    return <button onClick={updateState}
                   className={(active ? `active ` : ``) + (!twoColumnMode ? `single-plan-variant ` : `alternative-plan-variant `) + ((state.mainProps.hideSaleBadge || !planVariantForPeriod?.sale_badge) ? `without-sale-badge ` : '') + `text-left p-4 tile relative focus:ring`}
                   {...{disabled}}
        >
        {!state.mainProps.hideSaleBadge && planVariantForPeriod?.sale_badge &&
            <div className="fifty-percent-off-label">
                <div>{planVariantForPeriod.sale_badge}</div>
            </div>
        }
        {twoColumnMode && <span className="block text-xl font-medium leading-[normal]">{periodLabel}</span>}
        <div className={!twoColumnMode ? 'flex items-center gap-2' : ''}>
            <span className={(planVariantForPeriod === null ? 'skeleton ' : '') + (twoColumnMode ? 'text-3xl ' : 'text-[40px] ') + `font-bold`}>{planVariantForPeriod === null ? <>?? &euro;</> : formatCurrency(getMonthlyPriceForPlanVariant(planVariantForPeriod), true)}</span>
            <span className="text-gray-dark text-lg">{strikethroughPrice}/mtl{(!twoColumnMode && isAnnualVariant) ? <> bei jährlicher Vertragslaufzeit</> : ''}</span>
        </div>
        {active && twoColumnMode && <img src={check_icon} alt="" className="absolute top-4 right-4" />}
    </button>
}
